<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title>
        <ProductCardHeader :product-id="product.id" />
      </v-card-title>
      <v-card-text class="p-3" style="color: #4F4F4F">

        <v-row class="pl-3 mb-3">
          <v-flex style="text-align: left">
            HawkSoft’s Self-service Certificates allows you to empower trusted clients to access Certificates of Insurance on the web and add new Cert Holders as needed. <a href="https://www.hawksoft.com/self-service-certificates/" target="_blank">To learn more, click here.</a>
          </v-flex>
        </v-row>

        <ProductCardSubscriptionRow :is-subscribed="isSubscribed" :name="product.name" />

        <v-row class="pl-3 my-3">
          <div style="text-align: left">
            Active subscriptions can be cancelled at any time to avoid further charges.
          </div>
        </v-row>

        <!-- Pricing Table -->
        <v-row v-if="!isSubscribed" justify="center" class="my-3">
          <v-col cols="8">
            <v-row>
              <v-divider />
            </v-row>
            <v-row>
              <div><strong>Introductory Pricing</strong> (includes unlimited certificate generation)</div>
            </v-row>
            <v-row>
              <v-divider />
            </v-row>
            <v-row>
              $49 Per Month
            </v-row>
          </v-col>
        </v-row>

        <!-- Action Buttons -->
        <v-row v-if="isSubscribed" class="pl-3 my-3">
          <router-link
            to="/product/selfServeCerts/unsubscribe"
          >
            Cancel My Subscription
          </router-link>
        </v-row>
        <v-row v-else>
          <v-col>
            <v-row justify="center">
              <v-btn :disabled="!Agreed" height="50px" color="#FF9E15" @click="subscribe()">
                <span v-if="isTrialAvailable">Start 30-day Free Trial</span>
                <span v-else>Buy Now</span>
              </v-btn>
            </v-row>
            <v-row justify="center" align="center">
              <v-checkbox v-model="Agreed" />
              <!-- Hardcoding URL here, rather than app-management. The values there are not editable, as the product isn't using the data-share option there.-->
              <span class="pb-1 body-1">I agree to the <a href="https://www.hawksoft.com/terms/selfservicecerts" target="_blank">Terms and Conditions</a></span>
            </v-row>
          </v-col>
        </v-row>

        <!-- How it works list -->
        <v-row class="pl-3">
          How it works:
        </v-row>
        <v-row class="pl-3">
          <div>
            <ol class="pb-3">
              <li style="text-align: left">
                Create a Certificate of Insurance in HawkSoft’s Certificate Wizard
              </li>
              <li style="text-align: left">
                Click “Publish,” when the Certificate is complete
              </li>
              <li style="text-align: left">
                HawkSoft generates a link for your insured. Copy this link, then email or text it to your insured.
              </li>
              <li style="text-align: left">
                The insured uses the link to securely access the Certificate of Insurance. They can generate a Certificate for an existing Cert Holder, or add a new one.
                <ol type="a">
                  <li style="text-align: left">The agent who clicked publish receives a notification whenever a Certificate is generated in Self-service Certificates.</li>
                </ol>
              </li>
            </ol>
          </div>
        </v-row>

        <v-row class="pl-3">
          <div style="text-align: left" class="pt-3">
            Self-service Certificates is mobile-responsive.
          </div>
        </v-row>

      </v-card-text>

      <!-- Return to marketplace -->
      <v-card-actions>
        <v-row class="pa-3">
          <v-btn @click="returnToMarketplace()">Return to Marketplace</v-btn>
        </v-row>
      </v-card-actions>

    </v-card>
  </v-col>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import productIdMappingMixin from '@/mixins/productIdMappingMixin';
import ProductCardHeader from '@/components/products/shared/ProductCardHeader';
import ProductCardSubscriptionRow from '@/components/products/shared/ProductCardSubscriptionRow';

export default {
  name: 'SelfServeCerts',
  components: {
    ProductCardHeader,
    ProductCardSubscriptionRow
  },
  mixins: [productIdMappingMixin],
  data () {
    return {
      Agreed: false
    };
  },
  computed: {
    ...mapGetters(['getProductByProductId']),
    product () {
      return this.getProductByProductId(this.getProductId('selfCerts'));
    },
    isSubscribed () {
      var product = this.getProductByProductId(this.getProductId('selfCerts'));
      if (product) {
        return product.isSubscribed;
      }
      return false;
    },
    isTrialAvailable () {
      var product = this.getProductByProductId(this.getProductId('selfCerts'));
      if (product) {
        return product.isTrialAvailable;
      }
      return false;
    }
  },
  methods: {
    ...mapActions(['setProductSubscription']),
    returnToMarketplace () {
      this.$router.push('/marketplace');
    },
    async subscribe () {
      await this.$api.acceptDataShareTermsAndConditions(this.product.id); // sets Terms/Conditions Acceptance
      await this.$api.setSubscriptionDetailed(this.product.id, true, null, true); // Updates API
      // Should check API results for errors
      this.setProductSubscription({ productId: this.product.id, subscription: true }); // Updates local store
      this.$router.push('/product/selfServeCerts/success');
    }
  }
};

</script>
